import React from 'react';
import { Badge } from '@lognai/synapse-design-system-v2';
import { Flag } from '@lognai/synapse-design-system-v2/icons';
import type { TaskPriority } from '../../types/tasks';
import { PRIORITY_LABELS } from '../../types/tasks';

const PRIORITY_CLASSES: Record<TaskPriority, string> = {
  high: 'bg-red-500/15 text-red-500 border-red-500/30',
  medium: 'bg-amber-500/15 text-amber-500 border-amber-500/30',
  low: 'bg-slate-500/15 text-slate-400 border-slate-500/30',
};

export interface TaskPriorityBadgeProps {
  priority: TaskPriority;
}

export const TaskPriorityBadge: React.FC<TaskPriorityBadgeProps> = ({ priority }) => (
  <Badge variant="outline" className={`gap-1 ${PRIORITY_CLASSES[priority]}`}>
    <Flag className="h-3 w-3" />
    {PRIORITY_LABELS[priority]}
  </Badge>
);
